import { SIGNUP_NEW } from 'actions/Types';

export default function signUpInProgress(state = false, action) {
  if (action.type === `${SIGNUP_NEW}`) {
    return true;
  }

  if (action.type === `${SIGNUP_NEW}_SUCCESS`) {
    return false;
  }

  if (action.type === `${SIGNUP_NEW}_FAILURE`) {
    return false;
  }

  return state;
}
